import { render, staticRenderFns } from "./commit-data.vue?vue&type=template&id=0951d862&scoped=true"
import script from "./commit-data.vue?vue&type=script&lang=js"
export * from "./commit-data.vue?vue&type=script&lang=js"
import style0 from "./commit-data.vue?vue&type=style&index=0&id=0951d862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0951d862",
  null
  
)

export default component.exports